
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import {openMap} from '@/utils/commons';
export default {
name: "delivery-detail",
components:{Swiper,SwiperItem},
data(){
return{
asnId:null,
asn:{},
selectModel:'base',
showImgBol:false,
showImgSrc:'',
detailList:[{}],
imgList:[],
imgBaseUrl:process.env.API_ROOT,
bookingDistance:2000
}
},
methods:{
backMyDriver(){
this.$router.replace('/driver/my-delivery');
},
changeShowModel(str){
this.selectModel = str;
},
changeShow(data){
if(data.cellShow){
this.$set(data,'cellShow',false);
return;
}
this.$set(data,'cellShow',true);
},
showImg(item){
this.showImgSrc = item;
this.showImgBol = true;
},
closeImg(){
this.showImgBol = false;
},
viewMap(){
if(this.asn.shipAddress){
openMap(this.asn.shipAddress);
}
},
getDetail(){
this.$loadingShow();
this.$get(`api/asn/${this.asnId}`).then((res) => {
if(res.driStatus === 'WAITING_ORDER'){
this.getCurrent();
}
this.asn = res;
this.imgList = [];
if(res.plantAttachment && res.plantAttachment.attachFile){
res.plantAttachment.attachFile.forEach((item) => {
let str = this.imgBaseUrl + 'api/file/download/' + item.key;
this.imgList.push(str);
})
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
},
changeStatus(str){
let notice;
if(str === 'DELIVERY'){
notice = '确认立即接单？';
}else if(str === 'BOOKING'){
notice = '确认预约卸货？';
}else if(str === 'FINISH'){
notice = '确认完成送货？';
}else{
notice = '确认取消接单？';
}
this.$vux.confirm.show({
title:notice,
onConfirm:()=>{
if(str === 'BOOKING' && this.asn.shipAddress){
this.booking();
}else{
this.$loadingShow();
this.asn.driStatus = str;
this.$put('api/asn',this.asn).then((res) => {
this.$vux.toast.text('操作成功');
this.$loadingHide();
this.getDetail();
}).catch(() => {
this.$loadingHide();
this.getDetail();
})
}
}
});
},
deleteAsn(){
this.$vux.confirm.show({
title:'确认删除该送货单？',
onConfirm:() => {
this.$loadingShow();
this.$del(`api/asn/${this.asnId}`).then((res) => {
this.$vux.toast.text('删除成功');
this.$router.replace('/driver/my-delivery');
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
}
})
},
getCurrent(){
this.$get('api/person/current').then((res) => {
this.asn.carrier = res.name;
this.asn.carrierTel = res.login;
this.$get(`api/driver/tel/${res.login}`).then((val) =>{
this.driverId = val.id;
this.asn.carrierId = this.driverId;
this.asn.carNumber = val.carNumber;
})
})
},

getBookingDistance(){
this.$get('api/config-para/search-with-list',{mainCode:'bookingDistance'}).then((res) => {
if(res && res.configParaDts && res.configParaDts[0] && res.configParaDts[0].paraValue1){
this.bookingDistance = Number(res.configParaDts[0].paraValue1);
}
})
},
booking(){
let that = this;
let local = new Promise((resolve,reject) => {
AMap.plugin('AMap.Geolocation', function() {
var geolocation = new AMap.Geolocation({

enableHighAccuracy: true,

timeout: 10000,

buttonOffset: new AMap.Pixel(10, 20),

zoomToAccuracy: true,

buttonPosition: 'RB'
});

geolocation.getCurrentPosition();
AMap.event.addListener(geolocation, 'complete', onComplete);
AMap.event.addListener(geolocation, 'error', onError);
function onComplete (data) {
resolve(data);
}
function onError (data) {
that.$vux.toast.text('请打开手机GPS定位，并授权微信使用GPS定位。');
reject(data);
}
});
});
let destin = new Promise((resolve,reject) => {
AMap.plugin('AMap.Geocoder',function () {
var geocoder = new AMap.Geocoder();
geocoder.getLocation(that.asn.shipAddress,(status,result) => {
if (status === 'complete' && result.info === 'OK'){
resolve(result);
}else{
reject();
}
})
});
});
this.$loadingShow();
Promise.all([local,destin]).then((res) => {
let p1 = res[0].position;
let p2 = res[1].geocodes[0].location;
let dis = Math.round(p1.distance(p2));
this.$loadingHide();
if(dis > this.bookingDistance){
this.$vux.toast.text(`距离收货地址${this.bookingDistance}米之内，才能预约卸货，当前位置距离收货地址还有${dis}米`);
}else{
this.asn.driStatus = 'BOOKING';
this.$loadingShow();
this.$put('api/asn',this.asn).then((res) => {
this.$vux.toast.text('操作成功');
this.$loadingHide();
this.getDetail();
}).catch(() => {
this.$loadingHide();
this.getDetail();
})
}
}).catch(() => {
this.$loadingHide();
})
},
copyAdd(){
let textareaEl = document.createElement('textarea');
textareaEl.setAttribute('readonly', 'readonly'); 
textareaEl.value = this.asn.shipAddress;
document.body.appendChild(textareaEl);
textareaEl.select();
document.execCommand('copy');
document.body.removeChild(textareaEl);
this.$vux.toast.text('复制成功');
}
},
mounted(){
this.asnId = this.$route.params.id;
this.getDetail();
this.getBookingDistance();
}
}



// WEBPACK FOOTER //
// ./src/page/driver/delivery-detail.vue